import { ReactNode } from 'react';
import { create } from 'zustand';
import { ButtonProps } from '../components/inputs/button';

interface ButtonHandler extends Omit<ButtonProps, 'children' | 'onClick'> {
  text: ReactNode | string;
  children?: undefined;
  onClick?: () => Promise<void> | void;
}

interface AlertState {
  message?: string;
  show?: boolean;
  title?: string;
  buttons?: ButtonHandler[];
}

interface AlertAction {
  alert: (title: string, message: string, buttons?: ButtonHandler[]) => void;
  setAlertState: (state: Partial<AlertState>) => void;
}

const useAlertStore = create<AlertState & AlertAction>(set => ({
  alert: (title, message, buttons) => {
    set({ show: true, title, message, buttons });
  },
  setAlertState: state => set(state),
}));

export default useAlertStore;
